import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { formatRFC3339 } from 'date-fns/esm';
import {
  ResourceConsumptionGroupSearchRequest,
  ResourceConsumptionGroupSearchResponse
} from './resource-consumption-base.model';

@Injectable({
  providedIn: 'root'
})
export class ResourceConsumptionBaseApi {
  constructor(private http: HttpClient) {}

  resourceConsumptionGroup(request: ResourceConsumptionGroupSearchRequest): Observable<ResourceConsumptionGroupSearchResponse> {
    return this.http.post<ResourceConsumptionGroupSearchResponse>('/api/resource-consumption/group-by-search', {
      ...request,
      from: request.from && !request.limit ? (typeof request.from === 'string' ? request.from : formatRFC3339(request.from)) : undefined,
      till: request.till && !request.limit ? (typeof request.till === 'string' ? request.till : formatRFC3339(request.till)) : undefined
    });
  }
}